// This component will be used to hold the text + selection of installments
// will be used by the tenant AND the MANAGER

// to easily copy and paste components
import React from 'react';
import { withTranslation } from 'react-i18next';
import Parent from '../parent';
import InstallmentsSelect from "../installmentsSelect";
import {BllinkLogger} from "../utils/bllink_loggers";
import CacheData from "../utils/cacheData";
import { constants } from "../constants/constants";
import { i18n } from "../translations";
import './installmentBox.css';

export class InstallmentsBox extends Parent {
    constructor(props) {
        super(props);

        BllinkLogger.info(`InstallmentsBox props`, this.props);
        const shouldRenderNumberOfInstallments = (!props.isViewedAsManager);
        const shouldRenderManagerOptions = (props.isViewedAsManager);


        this.onPaymentMethodChangeFunc = this.onPaymentMethodChange.bind(this);

        this.state = {
            shouldRenderNumberOfInstallments: shouldRenderNumberOfInstallments,
            shouldRenderManagerOptions: shouldRenderManagerOptions,
            managerResult: {}
        }
        // todo determine text items by manager or not
        // also determine width ratio
    }

    async getPaymentMethodResult(props) {
        // get selected method
        BllinkLogger.info(`before decide who should render `, props);
        const shouldRenderManagerOptions = (props.isViewedAsManager);

        let result =  {
            shouldRenderManagerOptions: shouldRenderManagerOptions
        }
        const paymentOptions = await this.getManagerOptions();

        if (shouldRenderManagerOptions){
            result = {...result, ...paymentOptions}
        }

        return result
    }

    async getManagerOptions() {
        const options = {buildingID: this.props.buildingID, apartmentNumber: this.props.apartmentNumber}
        let cachedSelection = CacheData.fetchCache('PaymentMethodSelected', options)
        BllinkLogger.info(`cached choice for manager methods is `, cachedSelection);
        cachedSelection = (cachedSelection && cachedSelection.selectedPaymentMethod);
        let paymentOptions = [];
        if (!this.props.shouldHideCreditCardOption){
            // https://app.asana.com/0/1123966772501425/1199546685691687
            // enable offline payments for future months (not just the next month)
            paymentOptions.push({value: constants.managerPaymentsOptions.creditCard, label: i18n.t('offline_payments.credit_card')})
        }
        paymentOptions.push({value: constants.managerPaymentsOptions.cheque, label: i18n.t('offline_payments.cheque')})

        const isAdmin = await this.isAdmin();
        // const isDeveloper = await this.isDeveloper();
        const shouldAddChequeScanner = isAdmin || await this.isPartnerAllowedForChequeScanner();
        if (isAdmin) paymentOptions.push({value: constants.managerPaymentsOptions.tenantRecordKey, label: i18n.t('offline_payments.tenant_record')});
        if (shouldAddChequeScanner) paymentOptions.push({value: constants.managerPaymentsOptions.autoCheque, label: i18n.t('offline_payments.cheque_deposit')});

        paymentOptions.push({value: constants.managerPaymentsOptions.wire, label: i18n.t('offline_payments.wire')})
        paymentOptions.push({value: constants.managerPaymentsOptions.cash, label: i18n.t('offline_payments.cash')})

        const selectedPaymentMethod = cachedSelection || paymentOptions[0].value; //first available option

        if (!cachedSelection){
            CacheData.cache('PaymentMethodSelected', {
                selectedPaymentMethod: selectedPaymentMethod
            }, options)
        }

        const shouldNotRenderInstallmentsSelect = (
            selectedPaymentMethod !==
            constants.managerPaymentsOptions.creditCard
        )

        return {
            paymentOptions: paymentOptions,
            selectedPaymentMethod: selectedPaymentMethod,
            shouldNotRenderInstallmentsSelect: shouldNotRenderInstallmentsSelect
        }
    }


    onPaymentMethodChange(newMethod) {
        /*used by the manager to log offline payments like cheques */
        // should cancel the reward if needed

        BllinkLogger.info(`select installment ${this.props.name} onSelectChange ${newMethod}`);
        // save to cache or to global state

        const shouldNotRenderInstallmentsSelect = (
            newMethod !==
            constants.managerPaymentsOptions.creditCard
        )

        const newState = {
            selectedPaymentMethod: newMethod,
            shouldNotRenderInstallmentsSelect: shouldNotRenderInstallmentsSelect
        }
        this.setState({managerResult: newState})

        CacheData.cache('PaymentMethodSelected', newState, {buildingID: this.props.buildingID, apartmentNumber: this.props.apartmentNumber})

    }

    async componentDidMount() {
        const thisObj = this;
        let managerResult = await this.getPaymentMethodResult(this.props);
        BllinkLogger.info(`managerResult `, managerResult);

        this.setState({
            managerResult
        });

        // https://app.asana.com/0/1196545425570329/1199562987978294
        // should effect all boxes if one is changed
        if (this.props.isOneTime) {
            const key = constants.cache.cacheChanged('PaymentMethodSelected');
            document.addEventListener(key, async (e) => {
                managerResult = await thisObj.getManagerOptions();
                thisObj.setState({managerResult});
            }, false);
        }
    }

    render() {
        const {t} = this.props;
        const paymentMethod = this.state.shouldRenderManagerOptions ? <div className='label'>{t('offline_payments.type_of_payment')}:</div> : '';
        const textWidthClass = this.state.shouldRenderManagerOptions ? 'col-md-7 col-7': 'col-md-8 col-8';
        const amountsWidthClass = this.state.shouldRenderManagerOptions ? 'col-md-5 col-5': 'col-md-4 col-4';
        const rowClass = this.props.isOneTime ? 'installmentBox d-flex text-center': 'installmentBox row pt-4';
        const textSideClass = this.props.isOneTime ? 'one-time-text': '';
        const AmountsSideClass = this.props.isOneTime ? '': '';
        const instalmentsSelectText = this.state.managerResult.shouldNotRenderInstallmentsSelect ? '': <div className='label'>{t('payments.number_of_installments')}:</div>;
        const firstPaymentSelectText = this.state.managerResult.shouldNotRenderInstallmentsSelect ? '': <div className='label'>{t('payments.first_payment')}:</div>;

        BllinkLogger.info(`installment box props`,  this.props);

        return (
            <div className={rowClass}>
                <div className={`${textWidthClass} ${textSideClass}`}>
                    <div className='label'>{t('payments.total_to_pay')}:</div>
                    {paymentMethod}
                    {instalmentsSelectText}
                    {firstPaymentSelectText}
                </div>
                <div className={`${amountsWidthClass} ${AmountsSideClass}`}>
                    <InstallmentsSelect
                        months={this.props.months}
                        currency={this.props.currency}
                        partPay={this.props.partPay}
                        maxNumberOfInstallments={this.props.maxNumberOfInstallments}
                        totalReward={this.props.totalReward}
                        total={this.props.total}
                        name={this.props.name}
                        data={this.props.data}
                        managerOptions={this.state.managerResult}
                        onPaymentMethodChanged={this.onPaymentMethodChangeFunc}
                        defaultNumberOfInstallments={this.props.defaultNumberOfInstallments}
                        selectedNumberOfInstallments={this.props.selectedNumberOfInstallments}
                        shouldHideCreditCardOption={this.props.shouldHideCreditCardOption}
                        isViewedAsManager={this.props.isViewedAsManager}
                        buildingID={this.props.buildingID}
                        apartmentNumber={this.props.apartmentNumber}
                        isOneTime={this.props.isOneTime}
                        onChange={this.props.onChanged}
                    />
                </div>
            </div>
        )
    }
}

export default withTranslation()(InstallmentsBox);


